package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets0 {
  internal val draft_txt: AssetResource by lazy { init_draft_txt() }

  internal val iyov_tehilim_speakers_json: AssetResource by lazy { init_iyov_tehilim_speakers_json()
      }

  internal val numbers_json: AssetResource by lazy { init_numbers_json() }

  internal val sedarim_json: AssetResource by lazy { init_sedarim_json() }

  internal val verses_per_chapter_csv: AssetResource by lazy { init_verses_per_chapter_csv() }

  internal val _10_melachim_a_01_txt: AssetResource by lazy { init__10_melachim_a_01_txt() }

  internal val _10_melachim_a_02_txt: AssetResource by lazy { init__10_melachim_a_02_txt() }

  internal val _10_melachim_a_03_txt: AssetResource by lazy { init__10_melachim_a_03_txt() }

  internal val _10_melachim_a_04_txt: AssetResource by lazy { init__10_melachim_a_04_txt() }

  internal val _10_melachim_a_05_txt: AssetResource by lazy { init__10_melachim_a_05_txt() }

  internal val _10_melachim_a_06_txt: AssetResource by lazy { init__10_melachim_a_06_txt() }

  internal val _10_melachim_a_07_txt: AssetResource by lazy { init__10_melachim_a_07_txt() }

  internal val _10_melachim_a_08_txt: AssetResource by lazy { init__10_melachim_a_08_txt() }

  internal val _10_melachim_a_09_txt: AssetResource by lazy { init__10_melachim_a_09_txt() }

  internal val _10_melachim_a_10_txt: AssetResource by lazy { init__10_melachim_a_10_txt() }

  internal val _10_melachim_a_11_txt: AssetResource by lazy { init__10_melachim_a_11_txt() }

  internal val _10_melachim_a_12_txt: AssetResource by lazy { init__10_melachim_a_12_txt() }

  internal val _10_melachim_a_13_txt: AssetResource by lazy { init__10_melachim_a_13_txt() }

  internal val _10_melachim_a_14_txt: AssetResource by lazy { init__10_melachim_a_14_txt() }

  internal val _10_melachim_a_15_txt: AssetResource by lazy { init__10_melachim_a_15_txt() }

  internal val _10_melachim_a_16_txt: AssetResource by lazy { init__10_melachim_a_16_txt() }

  internal val _10_melachim_a_17_txt: AssetResource by lazy { init__10_melachim_a_17_txt() }

  internal val _10_melachim_a_18_txt: AssetResource by lazy { init__10_melachim_a_18_txt() }

  internal val _10_melachim_a_19_txt: AssetResource by lazy { init__10_melachim_a_19_txt() }

  internal val _10_melachim_a_20_txt: AssetResource by lazy { init__10_melachim_a_20_txt() }

  internal val _10_melachim_a_21_txt: AssetResource by lazy { init__10_melachim_a_21_txt() }

  internal val _10_melachim_a_22_txt: AssetResource by lazy { init__10_melachim_a_22_txt() }

  internal val _11_melachim_b_01_txt: AssetResource by lazy { init__11_melachim_b_01_txt() }

  internal val _11_melachim_b_02_txt: AssetResource by lazy { init__11_melachim_b_02_txt() }

  internal val _11_melachim_b_03_txt: AssetResource by lazy { init__11_melachim_b_03_txt() }

  internal val _11_melachim_b_04_txt: AssetResource by lazy { init__11_melachim_b_04_txt() }

  internal val _11_melachim_b_05_txt: AssetResource by lazy { init__11_melachim_b_05_txt() }

  internal val _11_melachim_b_06_txt: AssetResource by lazy { init__11_melachim_b_06_txt() }

  internal val _11_melachim_b_07_txt: AssetResource by lazy { init__11_melachim_b_07_txt() }

  internal val _11_melachim_b_08_txt: AssetResource by lazy { init__11_melachim_b_08_txt() }

  internal val _11_melachim_b_09_txt: AssetResource by lazy { init__11_melachim_b_09_txt() }

  internal val _11_melachim_b_10_txt: AssetResource by lazy { init__11_melachim_b_10_txt() }

  internal val _11_melachim_b_11_txt: AssetResource by lazy { init__11_melachim_b_11_txt() }

  internal val _11_melachim_b_12_txt: AssetResource by lazy { init__11_melachim_b_12_txt() }

  internal val _11_melachim_b_13_txt: AssetResource by lazy { init__11_melachim_b_13_txt() }

  internal val _11_melachim_b_14_txt: AssetResource by lazy { init__11_melachim_b_14_txt() }

  internal val _11_melachim_b_15_txt: AssetResource by lazy { init__11_melachim_b_15_txt() }

  internal val _11_melachim_b_16_txt: AssetResource by lazy { init__11_melachim_b_16_txt() }

  internal val _11_melachim_b_17_txt: AssetResource by lazy { init__11_melachim_b_17_txt() }

  internal val _11_melachim_b_18_txt: AssetResource by lazy { init__11_melachim_b_18_txt() }

  internal val _11_melachim_b_19_txt: AssetResource by lazy { init__11_melachim_b_19_txt() }

  internal val _11_melachim_b_20_txt: AssetResource by lazy { init__11_melachim_b_20_txt() }

  internal val _11_melachim_b_21_txt: AssetResource by lazy { init__11_melachim_b_21_txt() }

  internal val _11_melachim_b_22_txt: AssetResource by lazy { init__11_melachim_b_22_txt() }

  internal val _11_melachim_b_23_txt: AssetResource by lazy { init__11_melachim_b_23_txt() }

  internal fun values(): List<AssetResource> = listOf(draft_txt, iyov_tehilim_speakers_json,
      numbers_json, sedarim_json, verses_per_chapter_csv, _10_melachim_a_01_txt,
      _10_melachim_a_02_txt, _10_melachim_a_03_txt, _10_melachim_a_04_txt, _10_melachim_a_05_txt,
      _10_melachim_a_06_txt, _10_melachim_a_07_txt, _10_melachim_a_08_txt, _10_melachim_a_09_txt,
      _10_melachim_a_10_txt, _10_melachim_a_11_txt, _10_melachim_a_12_txt, _10_melachim_a_13_txt,
      _10_melachim_a_14_txt, _10_melachim_a_15_txt, _10_melachim_a_16_txt, _10_melachim_a_17_txt,
      _10_melachim_a_18_txt, _10_melachim_a_19_txt, _10_melachim_a_20_txt, _10_melachim_a_21_txt,
      _10_melachim_a_22_txt, _11_melachim_b_01_txt, _11_melachim_b_02_txt, _11_melachim_b_03_txt,
      _11_melachim_b_04_txt, _11_melachim_b_05_txt, _11_melachim_b_06_txt, _11_melachim_b_07_txt,
      _11_melachim_b_08_txt, _11_melachim_b_09_txt, _11_melachim_b_10_txt, _11_melachim_b_11_txt,
      _11_melachim_b_12_txt, _11_melachim_b_13_txt, _11_melachim_b_14_txt, _11_melachim_b_15_txt,
      _11_melachim_b_16_txt, _11_melachim_b_17_txt, _11_melachim_b_18_txt, _11_melachim_b_19_txt,
      _11_melachim_b_20_txt, _11_melachim_b_21_txt, _11_melachim_b_22_txt, _11_melachim_b_23_txt)
}

private fun init_draft_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/draft.txt\")") as String, rawPath = "draft.txt")

private fun init_iyov_tehilim_speakers_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/iyov_tehilim_speakers.json\")") as String, rawPath =
    "iyov_tehilim_speakers.json")

private fun init_numbers_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/numbers.json\")") as String, rawPath = "numbers.json")

private fun init_sedarim_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/sedarim.json\")") as String, rawPath = "sedarim.json")

private fun init_verses_per_chapter_csv(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/verses_per_chapter.csv\")") as String, rawPath =
    "verses_per_chapter.csv")

private fun init__10_melachim_a_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-01.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-01.txt")

private fun init__10_melachim_a_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-02.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-02.txt")

private fun init__10_melachim_a_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-03.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-03.txt")

private fun init__10_melachim_a_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-04.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-04.txt")

private fun init__10_melachim_a_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-05.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-05.txt")

private fun init__10_melachim_a_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-06.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-06.txt")

private fun init__10_melachim_a_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-07.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-07.txt")

private fun init__10_melachim_a_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-08.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-08.txt")

private fun init__10_melachim_a_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-09.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-09.txt")

private fun init__10_melachim_a_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-10.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-10.txt")

private fun init__10_melachim_a_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-11.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-11.txt")

private fun init__10_melachim_a_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-12.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-12.txt")

private fun init__10_melachim_a_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-13.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-13.txt")

private fun init__10_melachim_a_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-14.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-14.txt")

private fun init__10_melachim_a_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-15.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-15.txt")

private fun init__10_melachim_a_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-16.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-16.txt")

private fun init__10_melachim_a_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-17.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-17.txt")

private fun init__10_melachim_a_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-18.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-18.txt")

private fun init__10_melachim_a_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-19.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-19.txt")

private fun init__10_melachim_a_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-20.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-20.txt")

private fun init__10_melachim_a_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-21.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-21.txt")

private fun init__10_melachim_a_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_10_melachim_a-22.txt\")") as String, rawPath =
    "allChapters/_10_melachim_a-22.txt")

private fun init__11_melachim_b_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-01.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-01.txt")

private fun init__11_melachim_b_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-02.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-02.txt")

private fun init__11_melachim_b_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-03.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-03.txt")

private fun init__11_melachim_b_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-04.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-04.txt")

private fun init__11_melachim_b_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-05.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-05.txt")

private fun init__11_melachim_b_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-06.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-06.txt")

private fun init__11_melachim_b_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-07.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-07.txt")

private fun init__11_melachim_b_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-08.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-08.txt")

private fun init__11_melachim_b_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-09.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-09.txt")

private fun init__11_melachim_b_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-10.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-10.txt")

private fun init__11_melachim_b_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-11.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-11.txt")

private fun init__11_melachim_b_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-12.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-12.txt")

private fun init__11_melachim_b_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-13.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-13.txt")

private fun init__11_melachim_b_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-14.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-14.txt")

private fun init__11_melachim_b_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-15.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-15.txt")

private fun init__11_melachim_b_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-16.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-16.txt")

private fun init__11_melachim_b_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-17.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-17.txt")

private fun init__11_melachim_b_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-18.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-18.txt")

private fun init__11_melachim_b_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-19.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-19.txt")

private fun init__11_melachim_b_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-20.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-20.txt")

private fun init__11_melachim_b_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-21.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-21.txt")

private fun init__11_melachim_b_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-22.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-22.txt")

private fun init__11_melachim_b_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-23.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-23.txt")

public actual val SharedRes.assets.draft_txt: AssetResource
  get() = CommonMainAssets0.draft_txt

public actual val SharedRes.assets.iyov_tehilim_speakers_json: AssetResource
  get() = CommonMainAssets0.iyov_tehilim_speakers_json

public actual val SharedRes.assets.numbers_json: AssetResource
  get() = CommonMainAssets0.numbers_json

public actual val SharedRes.assets.sedarim_json: AssetResource
  get() = CommonMainAssets0.sedarim_json

public actual val SharedRes.assets.verses_per_chapter_csv: AssetResource
  get() = CommonMainAssets0.verses_per_chapter_csv

public actual val SharedRes.assets.allChapters._10_melachim_a_01_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_01_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_02_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_02_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_03_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_03_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_04_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_04_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_05_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_05_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_06_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_06_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_07_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_07_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_08_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_08_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_09_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_09_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_10_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_10_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_11_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_11_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_12_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_12_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_13_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_13_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_14_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_14_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_15_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_15_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_16_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_16_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_17_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_17_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_18_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_18_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_19_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_19_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_20_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_20_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_21_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_21_txt

public actual val SharedRes.assets.allChapters._10_melachim_a_22_txt: AssetResource
  get() = CommonMainAssets0._10_melachim_a_22_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_01_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_01_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_02_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_02_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_03_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_03_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_04_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_04_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_05_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_05_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_06_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_06_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_07_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_07_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_08_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_08_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_09_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_09_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_10_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_10_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_11_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_11_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_12_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_12_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_13_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_13_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_14_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_14_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_15_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_15_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_16_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_16_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_17_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_17_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_18_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_18_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_19_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_19_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_20_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_20_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_21_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_21_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_22_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_22_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_23_txt: AssetResource
  get() = CommonMainAssets0._11_melachim_b_23_txt
